export default __webpack_public_path__ + "static/media/profile-marker.4477cb5f.svg";